import React, { useRef, useEffect, forwardRef } from 'react';
import { Chart } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';
import { Chart as ChartJS } from 'chart.js/auto';
ChartJS.register(annotationPlugin, zoomPlugin);
const ChartJSWrapper = forwardRef((props, ref) => {
    const chartRef = useRef(null);
    useEffect(() => {
        if (chartRef.current && props.onChartRef) {
            props.onChartRef(chartRef.current); // Call the callback with the chart reference
        }
    }, [props.onChartRef]);
    return (React.createElement(Chart, { ref: ref || chartRef, type: props.type, data: props.data, options: props.options, style: props.style }));
});
export default ChartJSWrapper;
